export const getDownloadHref = () => {
    return 'http://plus.chongnengjihua.com/';
};

export const goDownload = () => {
    window.open('http://plus.chongnengjihua.com/', '_self');
};
